import { ComponentPropsWithoutRef } from 'react'

export function Warning20(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} {...props}>
      <path
        fillRule="evenodd"
        d="M2.899 18H17.1a1.75 1.75 0 0 0 1.549-2.565L11.549 1.942c-.656-1.246-2.442-1.246-3.098 0L1.35 15.435A1.75 1.75 0 0 0 2.899 18M9 6a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm2.25 8.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        clipRule="evenodd"
      />
    </svg>
  )
}
